import { render, staticRenderFns } from "./AppTitulo.vue?vue&type=template&id=9b992790&"
import script from "./AppTitulo.vue?vue&type=script&lang=js&"
export * from "./AppTitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports